import Immutable from 'immutable';
import * as types from './AdminSizeCharts.types';

const initialState = {
    actionType: 'list',
    items: [],
    item: {
        active: 1,
        deleted: 0,
    },
    fetchingElements: false,
    fetchingElement: false,
    duplicating: false,
    saving: false,
    deleting: false,
    idModal: null,
    table: [],
    totalRows: 0,
    totalColumns: 0,
    pagination: {
        totalElements: 0,
        activePage: 1,
        totalPages: 0,
        elementsPerPage: 15,
    },
    sort: {
        column: 'name',
        type: 'asc',
    },
    search: '',
    searchType: 'name',
}

export default function (state = initialState, action) {
    state = Immutable.fromJS(state);
    switch (action.type) {
        case types.FETCH_ELEMENTS:
            return state.setIn(['fetchingElements'], true).toJS();

        case types.FETCH_ELEMENTS_SUCCESS:
            return state.setIn(['fetchingElements'], false)
                .setIn(['items'], action.payload.elements)
                .setIn(['pagination', 'totalElements'], action.payload.totalElements)
                .setIn(['pagination', 'activePage'], action.payload.activePage)
                .setIn(['pagination', 'totalPages'], action.payload.totalPages)
                .setIn(['pagination', 'elementsPerPage'], action.payload.elementsPerPage)
                .toJS();

        case types.FETCH_ELEMENTS_ERROR:
            return state.setIn(['fetchingElements'], false).toJS();

        case types.FETCH_ELEMENT:
            return state.setIn(['fetchingElement'], true).toJS();

        case types.FETCH_ELEMENT_SUCCESS:
            return state.setIn(['fetchingElement'], false)
                .setIn(['item'], action.payload)
                .toJS();

        case types.FETCH_ELEMENT_ERROR:
            return state.setIn(['fetchingElement'], false).toJS();

        case types.SAVE_ELEMENT:
            return state.setIn(['saving'], true).toJS();

        case types.SAVE_ELEMENT_SUCCESS:
            return state.setIn(['saving'], false)
                .setIn(['item'], {
                    active: 1,
                    deleted: 0,
                })
                .toJS();

        case types.SAVE_ELEMENT_ERROR:
            return state.setIn(['saving'], false).toJS();

        case types.DELETE_ITEM:
            return state.setIn(['deleting'], true).toJS();

        case types.DELETE_ITEM_SUCCESS:
            return state.setIn(['deleting'], false)
                .setIn(['idModal'], null)
                .toJS();

        case types.DELETE_ITEM_ERROR:
            return state.setIn(['deleting'], false).toJS();

        case types.DUPLICATE_ITEM:
            return state.setIn(['duplicating'], true).toJS();

        case types.DUPLICATE_ITEM_SUCCESS:
            return state.setIn(['duplicating'], false).toJS();

        case types.DUPLICATE_ITEM_ERROR:
            return state.setIn(['duplicating'], false).toJS();

        case types.SET_ACTION_TYPE:
            return state.setIn(['actionType'], action.payload).toJS();

        case types.SET_ACTIVE_PAGE:
            return state.setIn(['pagination', 'activePage'], action.payload).toJS();

        case types.SET_SORT:
            return state.setIn(['sort', 'type'], action.payload.type)
                .setIn(['sort', 'column'], action.payload.column)
                .toJS();

        case types.SET_SEARCH:
            return state.setIn(['search'], action.payload).toJS();

        case types.SET_SEARCH_TYPE:
            return state.setIn(['searchType'], action.payload).toJS();

        case types.SET_FIELD:
            return state.setIn(['item', action.payload.field], action.payload.value).toJS();

        case types.SET_HISTORY:
            return state.setIn(['history'], action.payload).toJS();

        case types.SET_ID_MODAL:
            return state.setIn(['idModal'], action.payload).toJS();

        case types.SET_TABLE:
            return state.setIn(['table'], action.payload.table)
                .setIn(['totalRows'], action.payload.rows)
                .setIn(['totalColumns'], action.payload.cols)
                .toJS();

        case types.SET_TABLE_CELL:
            return state.updateIn(['table'], (table) => {
                let newTable = table.toJS();
                newTable[action.payload.row][action.payload.col] = action.payload.value;
                return newTable;
            }).toJS();

        case types.RESET_STATE:
            return initialState;

        default:
            return state.toJS();
    }
}